var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.220703 7.07009C0.220703 3.16021 3.46685 0 7.39339 0C11.331 0 14.5772 3.16021 14.5772 7.07009C14.5772 9.04034 13.8653 10.8695 12.6935 12.4198C11.4008 14.13 9.80757 15.62 8.01418 16.7896C7.60373 17.0599 7.2333 17.0803 6.78283 16.7896C4.97922 15.62 3.38595 14.13 2.10435 12.4198C0.931756 10.8695 0.220703 9.04034 0.220703 7.07009ZM5.0293 7.29009C5.0293 8.5999 6.09119 9.63007 7.39323 9.63007C8.69612 9.63007 9.76823 8.5999 9.76823 7.29009C9.76823 5.99048 8.69612 4.91016 7.39323 4.91016C6.09119 4.91016 5.0293 5.99048 5.0293 7.29009Z",
    fill: "#8A9099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconGray);
export default __webpack_public_path__ + "static/media/location-icon-gray.c61a6c4c667a2804e2774da7bacb5c2e.svg";
export { ForwardRef as ReactComponent };